export default {
    toList(value) {
        if(!value) {
            return '';
        }
        return `<ul><li>${value.join('</li><li>')}</li></ul>`;
    }
};



// WEBPACK FOOTER //
// ./src/filters/ArrayFilters.js